import { PropsWithChildren } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import styled from "styled-components";

const StyledReactMarkdownBase = styled(ReactMarkdown)`
  img {
    max-width: 100%;
    display: block;
    margin: auto;
    margin-bottom: 14px;
  }

  ul {
    margin-left: 1.5rem;
    list-style-type: disc;
  }

  ol {
    margin-left: 1.5rem;
    list-style-type: decimal;
  }

  blockquote {
    border-left: 4px solid rgb(219 221 222);
    padding: 0.5rem 1rem;
  }

  hr {
    border: none;
    border-bottom: 1px solid rgb(219 221 222);
    margin: 1rem 0;
  }

  a {
    color: #007ac6;
    text-decoration-line: underline;
  }

  h1 {
    font-size: 24px;
    color: #000000e5;
    margin-top: 14px;
    margin-bottom: 14px;
  }

  h2 {
    font-size: 20px;
    color: #000000e5;
    margin-top: 14px;
    margin-bottom: 14px;
  }

  h3 {
    font-size: 18px;
    color: #000000e5;
    margin-top: 14px;
    margin-bottom: 14px;
  }

  h4 {
    font-size: 16px;
    color: #000000e5;
    margin-top: 14px;
    margin-bottom: 14px;
  }

  h5 {
    font-size: 15px;
    color: #000000e5;
    margin-top: 14px;
    margin-bottom: 14px;
  }

  h6 {
    font-size: 14px;
    color: #000000e5;
    margin-top: 14px;
    margin-bottom: 14px;
  }
`;

function LinkRenderer(props: PropsWithChildren<{ href?: string }>) {
  return (
    <a
      href={props.href}
      target='_blank'
      rel='noopener noreferrer'
      aria-label={`${props.children} (opens in a new tab)`}
    >
      {props.children}
    </a>
  );
}

export function StyledReactMarkdown(props: React.ComponentProps<typeof ReactMarkdown>) {
  return <StyledReactMarkdownBase remarkPlugins={[remarkGfm]} components={{ a: LinkRenderer }} {...props} />;
}
